import IconBalanceGuard from '@/components/Icons/IconBalanceGuard.vue'
import IconBank from '@/components/Icons/IconBank.vue'
import IconBell from '@/components/Icons/IconBell.vue'
import IconCashAtm from '@/components/Icons/IconCashAtm.vue'
import IconCheckCircle from '@/components/Icons/IconCheckCircle.vue'
import IconEye from '@/components/Icons/IconEye.vue'
import IconHantecLogo from '@/components/Icons/IconHantecLogo.vue'
import IconHeadset from '@/components/Icons/IconHeadset.vue'
import IconLock from '@/components/Icons/IconLock.vue'
import IconMinus from '@/components/Icons/IconMinus.vue'
import IconPayout from '@/components/Icons/IconPayout.vue'
import IconPdf from '@/components/Icons/IconPdf.vue'
import IconPlus from '@/components/Icons/IconPlus.vue'
import IconTools from '@/components/Icons/IconTools.vue'
import IconApplePay from './IconApplePay.vue'
import IconBankTransfer from './IconBankTransfer.vue'
import IconMasterCard from './IconMasterCard.vue'
import IconPaypal from './IconPaypal.vue'
import IconVisa from './IconVisa.vue'
import IconPopout from '@/components/Icons/IconPopout.vue'
import IconCheckCircleGold from '@/components/Icons/IconCheckCircleGold.vue'
import IconShieldRed from '@/components/Icons/IconShieldRed.vue'

const icons = {
  IconApplePay,
  IconBankTransfer,
  IconMasterCard,
  IconPaypal,
  IconVisa,
  IconBell,
  IconCheckCircle,
  IconEye,
  IconLock,
  IconPayout,
  IconTools,
  IconHeadset,
  IconCashAtm,
  IconBank,
  IconPlus,
  IconMinus,
  IconPdf,
  IconPopout,
  IconBalanceGuard,
  IconCheckCircleGold,
  IconShieldRed,
  IconHantecLogo
}

export type IconsType = keyof typeof icons

type PascalToKebabCase<S extends string> = S extends `${infer T}${infer U}`
  ? `${Lowercase<T>}${U extends Capitalize<U> ? '-' : ''}${PascalToKebabCase<U>}`
  : S

type PascalToKebabCaseWithoutTrailingHyphen<S extends string> =
  PascalToKebabCase<S> extends `${infer P}-` ? P : PascalToKebabCase<S>

type RemovePrefix<S extends string> = S extends `Icon${infer Rest}` ? Rest : never

type TransformIconKeys<T extends Record<string, any>> = {
  [K in keyof T as PascalToKebabCaseWithoutTrailingHyphen<RemovePrefix<Extract<K, string>>>]: T[K]
}

export type IconNames = keyof TransformIconKeys<typeof icons>

export default icons
